export default __webpack_public_path__ + "static/media/Exede_Hero.5cdf9b59.png";